import BulkList from "./bulks_list"

export default function BulkExpandedList(props) {
    return (<div className="bulk_expanded_list">
        {props.fakeFilter.map((filter, index) => <div key={index} className="bulk_expanded_list_column">
            <BulkList filters={props.fakeFilter} currentBulk={props.currentBulk} setCurrentBulk={(e) => props.setCurrentBulk(e)} selectedFilter={null} key={index} expanded={true} data={props.data.filter(bulk => bulk.pallet_status_id === filter.id)} countries={props.countries} mainStatuses={props.mainStatuses} fakeFilter={props.fakeFilter} />
        </div>)}
    </div>)
}